// extracted by mini-css-extract-plugin
export default {"wrapper":"Sprats_wrapper__ZVCWZ","heading":"Sprats_heading__66Kuv","grid":"Sprats_grid__ff9XC"};